// eslint-disable-next-line import/prefer-default-export
export const PropertyOverviewTitle = {
  HomeType: 'Home Type',
  GarageSize: 'Garage Size',
  BuildingType: 'Building Type',
  LotSize: 'Lot Size',
  Community: 'Community',
  LandUse: 'Land Use',
  Beds: 'Beds',
  Heating: 'Heating',
  FullBaths: 'Full Baths',
  Cooling: 'Cooling',
  HalfBaths: 'Half Baths',
  ParkingSpace: 'Parking Space(s)',
  YearBuilt: 'Year Built',
  PropertyTaxes: 'Property Taxes',
  HOA: 'HOA',
  TimeOnBode: 'Time on Bōde',
  DaysOnPlatform: 'Days on Platform',
  DaysOnMarket: 'Days on Market',
  MLSNumber: 'MLS® #',
  BodeID: 'Bōde ID',
  SqftPrice: 'Price / Sqft',
  Style: 'Style',
};
